import { AbstractControl } from '@angular/forms';

export function validateNumber(c: AbstractControl) {
    let NUMBER_REGEX = /^\d*$/;

    // If the value of the control tests against the regex, there is no error (return null).
    return (c.value == null || c.value == '' || NUMBER_REGEX.test(c.value) ? null : {
        validateNumber: {
            valid: false
        }
    });
}